// extracted by mini-css-extract-plugin
export default {"table":"CommunityList_table__QLn1J"};